// - 1-7 classes - 7 Days per class
// - 12 classes - 60 days
// - 24 classes - 180 days
// - 36 classes - 270 days
// - 48 classes - 450 days 
// - 72 classes - 1000 days 
// - 96 classes - 1200 days 

export function createExpiryDays(classesCount: number){
    let count = 1;
    if(classesCount <= 96) {
        count = 1200;
    }
    if(classesCount <= 72) {
        count = 1000;
    } 
    if(classesCount <= 48){
        count = 450
    }
    if(classesCount <= 36){
        count = 270
    }
    if(classesCount <= 24){
        count = 180
    }
    if(classesCount <= 12){
        count = 60
    }
    if(classesCount <= 7){
        count = 7 * classesCount
    }
  
    return count
}